import { useTranslation } from "react-i18next";
import "./legal.css";

export function Terms() {
  const { t } = useTranslation();
  return (
    <article className="container legal">
      <h1>{t("terms.title")}</h1>
      <p className="legal__updated">{t("terms.lastUpdated")}</p>
      <p>{t("terms.intro")}</p>

      <h2>{t("terms.natureTitle")}</h2>
      <p>{t("terms.natureBody")}</p>

      <h2>{t("terms.pointsTitle")}</h2>
      <p>{t("terms.pointsBody")}</p>

      <h2>{t("terms.abuseTitle")}</h2>
      <p>{t("terms.abuseBody")}</p>

      <h2>{t("terms.noWarrantyTitle")}</h2>
      <p>{t("terms.noWarrantyBody")}</p>
    </article>
  );
}
